module.exports = __webpack_public_path__ + "static/2-6bcd794a2fef905e2e03f5274bde57cc.jpg";